import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Attribution from "./components/Attribution";

//Components
import Header from "./components/Header";
import Home from "./components/Home";
import Movie from "./components/Movie";
import ErrorHandler from "./components/ErrorHandler";

//Styles
import { GlobalStyle } from "./GlobalStyle";

function App() {
    return (
        <Router>
            <Header />
            <Attribution />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/movie/:movieId" element={<Movie />} />
                <Route path="/*" element={<ErrorHandler error={false} />} />
            </Routes>
            <GlobalStyle />
        </Router>
    );
}

export default App;
